import { combineReducers } from "redux"

import geocodingReducer from "redux/features/geocoding/geocodingSlice"
import dialogReducer from "redux/features/dialog/dialogSlice"
import noticeReducer from "redux/features/notice/noticeSlice"
import clientReducer from "redux/features/client/clientSlice"
import subscriptionReducer from "redux/features/subscription/subscriptionSlice"
import subscriptionEligibilityReducer from "redux/features/subscription_eligibility/subscriptionEligibilitySlice"
import tawkReducer from "redux/features/tawk/tawkSlice"
import consentReducer from "redux/features/consent/consentSlice"
import debtReducer from "redux/features/debt/debtSlice"
import debtPaymentReducer from "redux/features/debt_payment/debtPaymentSlice"
import paymentScheduleReducer from "redux/features/payment_schedule/paymentScheduleSlice"
import paymentScheduleDatesReducer from "redux/features/payment_schedule_dates/paymentScheduleDatesSlice"
import paymentMethodsReducer from "redux/features/payment_methods/paymentMethodsSlice"
import paymentReducer from "redux/features/payment/paymentSlice"
import batchPaymentReducer from "redux/features/batch_payment/batchPaymentSlice"
import planReducer from "redux/features/plan/planSlice"
import productReducer from "redux/features/product/productSlice"
import productPaymentReducer from "redux/features/product_payment/productPaymentSlice"
import purchasedProductReducer from "redux/features/purchased_product/purchasedProductSlice"
import settingsReducer from "redux/features/settings/settingsSlice"
import npsReducer from "redux/features/nps/npsSlice"
import managerReducer from "redux/features/manager/managerSlice"
import issueReducer from "redux/features/issue/issueSlice"
import verificationReducer from "redux/features/verification/verificationSlice"

export const features = combineReducers({
  client: clientReducer,
  subscription: subscriptionReducer,
  subscription_eligibility: subscriptionEligibilityReducer,
  tawk: tawkReducer,
  consent: consentReducer,
  debt: debtReducer,
  debt_payment: debtPaymentReducer,
  payment_schedule: paymentScheduleReducer,
  payment_schedule_dates: paymentScheduleDatesReducer,
  payment_methods: paymentMethodsReducer,
  payment: paymentReducer,
  subscription_payment: paymentReducer,
  batch_payment: batchPaymentReducer,
  plan: planReducer,
  product: productReducer,
  product_payment: productPaymentReducer,
  purchased_product: purchasedProductReducer,
  settings: settingsReducer,
  geocoding: geocodingReducer,
  dialog: dialogReducer,
  notice: noticeReducer,
  nps: npsReducer,
  manager: managerReducer,
  issue: issueReducer,
  verification: verificationReducer,
})
